import { render, staticRenderFns } from "./TakePicture.vue?vue&type=template&id=dd97f6ba&scoped=true"
import script from "./TakePicture.vue?vue&type=script&lang=js"
export * from "./TakePicture.vue?vue&type=script&lang=js"
import style0 from "./TakePicture.vue?vue&type=style&index=0&id=dd97f6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd97f6ba",
  null
  
)

export default component.exports